// extracted by mini-css-extract-plugin
module.exports = {"EledoTemplateList":"EledoTemplateList_EledoTemplateList__l29iS","ListCardContainer":"EledoTemplateList_ListCardContainer__1JeV8"};